import { render, staticRenderFns } from "./zsonmSlider.vue?vue&type=template&id=94f22954"
import script from "./zsonmSlider.vue?vue&type=script&lang=js"
export * from "./zsonmSlider.vue?vue&type=script&lang=js"
import style0 from "./zsonmSlider.vue?vue&type=style&index=0&id=94f22954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports